<template>
<div>
  <van-panel title="💰 钱包余额" :desc="amount" class="wallet">
    <div slot="footer">
      <van-button size="large" type="danger" @click="onWithdraw">点我提现</van-button>
      <div ref="hint">
        <van-cell title="可提现金额" :value="canWithdraw" icon="clock" class="can-withdraw" />
      </div>
      <van-notice-bar text="💡 淘宝结算日为确认收货的次月20-25日，返利到账后将第一时间推送消息通知。" />
    </div>
  </van-panel>

  <van-panel title="余额明细">
    <div slot="footer">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, index) in list"
          :key="index">
          <van-row>
            <van-col span="4">
              <h3>{{index+1}}</h3>
            </van-col>

            <van-col span="14">
              <h3>{{item.remark}}</h3>
              <p>{{item.mtime}}</p>
            </van-col>

            <van-col span="6">
              <h3>{{item.amount}}</h3>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </div>
  </van-panel>

  <!--<van-popup v-model="show1" class="withdraw_dlg" >
    <van-uploader :after-read="onRead" :before-read="startRead">
      <van-icon name="photograph" size="50px"/>
    </van-uploader>
    <div>首次提现：点击上传微信收款码</div>
    <van-notice-bar text="💡 Tips：收款码在【钱包】->【收付款】->【二维码收款】中可以找到噢。如果上传遇到问题，可以联系我们的客服处理噢。" />
  </van-popup>-->

  <van-popup v-model="show2" class="withdraw_dlg" >
    <van-field
      v-model="withdraw"
      label="提现金额"
      placeholder="请输入提现金额"
      required
    />
    <div>&nbsp;</div>
    <van-button type="danger" size="large" round @click="beforeClose" :loading="btn_loading">确认提现</van-button>
    <van-notice-bar text="💡 Tips：每日可提现一次，单次提现金额0.3~5000元。" />
  </van-popup>
</div>
</template>

<script>
import {
  Tag,
  Row,
  Col,
  Icon,
  Cell,
  List,
  Field,
  Panel,
  Popup,
  Toast,
  Button,
  Uploader,
  NoticeBar,
  CellGroup
} from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [List.name]: List,
    [Field.name]: Field,
    [Panel.name]: Panel,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [NoticeBar.name]: NoticeBar,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      amount: "-",
      canWithdraw: "-",
      list: [],
      loading: false,
      finished: false,
      pn: 0,
      ps: 5,
      //show1: false,
      show2: false,
      withdraw: 0,
      //has_wxp: 0
    };
  },
  methods: {
    loadWallet(openid) {
      this.$http
        .get("https://cb.xhare.cn/wallet", {
          params: { openid: openid, pn: this.pn, ps: this.ps }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              if (this.pn == 0) {
                this.amount = (parseFloat(res.data.amount) + parseFloat(res.data.amount_last_month)).toFixed(2);
                this.canWithdraw = res.data.amount;
                //this.has_wxp = res.data.has_wxp;
              }
              if (res.data.data.length < this.ps) {
                this.finished = true;
              }
              if (res.data.data.length > 0) {
                if (this.canWithdraw.length > 0) {
                  this.$refs.hint.style.display = "";
                }
                res.data.data.forEach(element => {
                  this.list.push({
                    amount: element.amount,
                    remark: element.remark,
                    mtime: element.mtime
                  });
                });
              }

              this.loading = false;
            }
            this.pn++;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23wallet&response_type=code&scope=snsapi_base&state=ucenter";
    },
    onLoad() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.loadWallet(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.loadWallet(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    },
    onWithdraw() {
      //if(this.has_wxp > 0) {
        this.withdraw = this.canWithdraw;
        this.show2 = true;
      //} else {
      //  this.show1 = true;
      //}
    },
    beforeClose() {
      if (/^[1-9]?[0-9]*(\.[0-9]{1,2})?$/.test(this.withdraw+"") == false) {
        Toast.fail("提现金额输入格式错误");
        return
      }
      let amount = parseInt(parseFloat(this.withdraw).toFixed(2) * 100);
      if (amount < 30) {
        Toast.fail("单次提现金额不能低于0.3元");
        return
      }
      if (amount > 500000) {
        Toast.fail("单次提现金额不能大于5000元");
        return
      }
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.$http
          .get("https://cb.xhare.cn/withdraw", {
            params: { openid: openid, amount: amount }
          })
          .then(
            function(res) {
              if (res.data.code != 0) {
                Toast.fail(res.data.msg);
              } else {
                Toast.success(res.data.msg);
                this.show2 = false;
                setTimeout(() => {
                  this.redirect();
                }, 500);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    },
    /*onRead(file) {
      Toast.clear();
      / * eslint-disable* /
      qrcode.init({
        success: function(wxp) {
          if (/^wxp:\/\/[\w-]+$/.test(wxp) == false) {
            Toast.fail("收款码格式有误，请检查后重新选择");
          } else {
            let openid = sessionStorage.getItem("openid");
            if (openid) {
              this.$http
                .get("https://cb.xhare.cn/wxp", {
                  params: { openid: openid, wxp: wxp }
                })
                .then(
                  function(res) {
                    if (res.data.code == 0) {
                      Toast.success("收款码更新成功");
                      this.show1 = false;
                      this.withdraw = this.canWithdraw;
                      this.show2 = true;
                      this.has_wxp = 1;
                    } else {
                      Toast.fail("更新收款码失败，请检查后重试");
                    }
                  }.bind(this)
                )
                .catch(
                  function() {
                    Toast.fail("更新收款码失败，请检查后重试");
                  }.bind(this)
                );
            }
          }
        }.bind(this),
        error: function(e) {
          Toast.fail("解析收款码出错：" + e);
        }.bind(this)
	    });
      / * eslint-disable* /
      qrcode.decode(file.content);
    },
    startRead() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '正在读取并解析收款码'
      });
      return true;
    }*/
  },
  mounted() {
    this.$refs.hint.style.display = "none";
  }
};
</script>

<style lang="less">
.wallet {
  .van-cell__label {
    font-size: 36px;
  }
}
.can-withdraw {
  color: red;
  font-size: 22px;
}
.van-popup {
  width: 80%;
}
.withdraw_dlg {
  color: chocolate;
  border-radius: 15px;
  padding: 50px 20px 20px 20px;
}
</style>
